import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CreateNotification } from "../../../../../components/notifier";
import { documentTagsService } from "../../../../../services/document/document-tags.service";

interface Variables {
  id: string;
  body: { Title?: string; eTagType?: string };
}

export const useUpdateDocumentTag = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (vars: Variables) => {
      return documentTagsService.update(vars.id, vars.body);
    },
  });

  const updateDocumentTag = (
    vars: Variables,
    options?: { successText?: string; errorText?: string; onSuccess?: (res: any) => void },
  ) => {
    mutation.mutate(vars, {
      onSuccess() {
        queryClient.invalidateQueries({ queryKey: ["document-tags"] });
        CreateNotification({ title: "Thành công", body: "Cập nhật thành công", icon: "/icons/success.png" });
      },
      onError() {
        // message.error(options?.errorText ?? "Cập nhật thất bại");
      },
    });
  };
  return { updateDocumentTag, ...mutation };
};
